/**
 * Consignação: o cadastro do veículo usa internamente `fixed` | `percent`,
 * mas a API pode persistir comissão fixa como `value` (ver VehicleForm toApiConsignmentCommissionType).
 * Qualquer tela que só compare `=== 'fixed'` quebra ao receber `value` da API.
 */
export function isConsignmentCommissionFixed(type: unknown): boolean {
  return type === 'fixed' || type === 'value';
}
